import { IconCheck } from "@tabler/icons-react";
import { cn } from "@/lib/utils";

type CouponProps = {
  image: React.ReactNode | string;
  title: string;
  description: string;
  children: React.ReactNode;
  footer: React.ReactNode;
  isActive?: boolean;
};

export const Coupon = ({image, title, description, children, footer, isActive = false}: CouponProps) => {
  return (
    <div className={cn("flex flex-col rounded-2xl p-0.5 pb-0", isActive ? "bg-(image:--discount-gradient)" : "bg-brand-grey4")}>
      <div className="relative flex-1 rounded-2xl bg-white p-4">
        {isActive ? <span className="-top-0.5 -right-0.5 absolute flex h-10 w-10 items-center justify-center rounded-tr-lg rounded-bl-lg bg-discount-coupons-3">
          <IconCheck className="h-5 w-5 text-white" />
        </span> : null}
        <header className="flex items-start gap-4 pb-3">
          <div className="flex h-14 w-14 items-center justify-center rounded-sm border border-brand-grey2 bg-white p-1">
            {image}
          </div>
          <div className="pr-10">
            <h3 className="mb-1 font-medium text-lg">{title}</h3>
            <p className="text-gray-500 text-sm">{description}</p>
          </div>
        </header>
        <section>
          {children}
        </section>
      </div>
      <footer className={cn("flex items-center justify-center p-2.5 font-bold text-sm", isActive && "text-white")}>
        {footer}
      </footer>
    </div>
  );
};

